export default __webpack_public_path__ + "static/media/buildings_only.8d108985.svg";